import http from '../../../../../../libs/http'

const api = `${process.env.VUE_APP_MICROSERVICE_API_DASHBOARD}`

const getListDetailsChartCatalogo = (query) => http.get(`${api}/compras-catalogo/list-details-chart-catalogo`, { params: { ...query } })

export {
  getListDetailsChartCatalogo
}
